module.exports = __webpack_public_path__ + "static/hero-c206adf2153464a756c4465625471288.jpg";